import { createContext } from 'react'

const ProviderManagementContext = createContext()

export default ProviderManagementContext
